<template lang="pug">
.main-container
  .container
    .bread
      el-breadcrumb(separator="/")
        el-breadcrumb-item(to="/") 研究会
        el-breadcrumb-item 比赛平台
    .carousel
      el-carousel(
        v-if="carousels.length > 0"
        :interval="5000"
        height="460px"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)")
        el-carousel-item(v-for="(item, index) in carousels" :key="index")
          img(:src="item.background", alt="" v-if="item.background")
          img(:src="palaceholder" v-else)
          .background
            h2
              strong {{ item.title }}
            //- div {{ item.desc }}
            el-button.todoBtn(type="primary" @click="showDetail(item.id, 'compete')") 新闻动态
      el-row.competes-content(:gutter="20")
        //- el-col(
          :xs="24"
          :sm="24"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)")
          Container.container-item(:showMore="carousels.length >= 20", title="比赛公告", footer="更多比赛", @getMore="getMoreCompete")
            el-row.topics-el-row(v-if="carousels.length != 0")
              el-col.topics-el-col(v-for="(item, index) in carousels", :key="index", :xs="24", :sm="12", )
                .img-content-first(@click="showDetail(item.id, 'compete')")
                  strong.title.two-line {{ item.title }}
                  img(:src="item.background", alt="" v-if="item.background")
                  img(:src="palaceholder" v-else)
            .topics-news-content(v-else)
              .empty
                img(src="/static/empty.svg", alt="")
                p 暂无比赛
        el-row.competes-content(:gutter="20")
          el-col(
            :xs="24"
            :sm="24"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)")
            Container.container-item(:showMore="competes.length >= 6", title="往届比赛", footer="更多比赛", @getMore="getMoreCompete")
              el-row.topics-el-row(v-if="competes.length != 0")
                el-col.topics-el-col(v-for="(item, index) in competes", :key="index", :xs="24", :sm="6", )
                  .grid-content.img-content(@click="showDetail(item.id, 'compete')")
                    img(:src="item.background", alt="" v-if="item.background")
                    img(:src="palaceholder" v-else)
                    .title.signle-line {{ item.title }}
                    .desc {{ item.desc }}
                    .comp-time {{ $utils.dateTimeString(item.created_at) }}
              .topics-news-content(v-else)
                .empty
                  img(src="/static/empty.svg", alt="")
                  p 暂无比赛
        //- el-col(:xs="24", :sm="6")
        //-   Container.container-item(:showMore="notifications.length >=5", title="通知", footer="更早的通知", @getMore="getMoreNotification")
        //-     .topics-news-content(v-if="notifications.length != 0")
        //-       .topics-news(v-for="(item, index) in notifications", :key="index", @click="showDetail(item.id, 'notification')")
        //-         span.topics-news-title {{ item.title }}
        //-         span.two-line {{ item.abstract }}
        //-     .topics-news-content(v-else)
        //-       .empty
        //-         img(src="/static/empty.svg", alt="")
        //-         p 暂无通知
</template>

<script>
import { mapActions } from 'vuex';
import Container from '@/components/common/Container';

export default {
  name: 'Compete',
  components: {
    Container,
  },
  data() {
    return {
      palaceholder: 'http://api.shsgzgzjxyjh.cn/system/images/attachments/000/000/167/original/u_776200233_317664553_fm_200_gp_0.jpg?1546403692',
      competes: [],
      notifications: [],
      carousels: [],
      page: 1,
      notePage: 1,
      loading: true,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions([
      'fetchTodoCount',
    ]),
    showDetail(id, type) {
      this.$router.push(`/competes/${id}?type=${type}`);
    },
    async getMoreNotification() {
      this.notePage += 1;
      try {
        const notification = await this.$apis.notification.getNotifications('compete', this.notePage, 9);
        this.notifications = this.notifications.concat(notification.data.notifications);
      } catch (error) {
        this.$message.warning('获取通知信息失败 ！');
      }
    },
    async getMoreCompete() {
      this.page += 1;
      try {
        const { data } = await this.$apis.userCompete.getHistoryCompetesList(this.page, 8);
        if (data) {
          this.competes = this.competes.concat(data);
        } else {
          this.$message.info('没有更多数据 ！');
        }
      } catch (error) {
        this.$message.warning('获取比赛信息失败 ！');
      }
    },
    async fetchData() {
      try {
        const { data } = await this.$apis.userCompete.getHistoryCompetesList(this.page, 8);
        this.competes = data;
        // const notification = await this.$apis.notification.getNotifications('compete', 1, 9);
        // this.notifications = notification.data.notifications;
        const carousels = await this.$apis.carousel.getCarousel();
        this.carousels = carousels.data;
        this.loading = false;
      } catch (error) {
        this.$message.warning('获取信息失败 ！');
        this.loading = false;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.main-container
  display flex
  flex-direction column
  justify-content center
  align-items center

.container
  width 100%
  max-width 1170px

.bread
  margin 20px 0px

.carousel
  .el-carousel__item
    border-radius 8px
    font-size 1.5em
    // opacity 0.75
    text-align center
    line-height 100px
    img
      width 100%
      height 100%
      -webkit-filter saturate(0.8)
    .background
      text-align center
      width 100%
      position absolute
      top 80px
      left 0
      .el-button
        border-radius 36px
        padding 10px 35px
  .el-carousel__item:nth-child(2n)
    background-color #99a9bf
  .el-carousel__item:nth-child(2n+1)
    background-color #d3dce6

.competes-content
  .container-item
    margin-top 20px
    .topics-el-row
      padding 10px 10px 20px 20px
      border 1px
      border-bottom-left-radius 8px
      border-bottom-right-radius 8px
      margin 0
      background #fff
      .topics-el-col
        min-height 265px
        padding 15px 15px 0 0
        border-radius 0
        // border-top 1px solid #D6DBE2
        // border-right 1px solid #D6DBE2
      .topics-el-col:nth-child(4n)
        border-radius 0
        // border-bottom 1px solid #D6DBE2
        border-right 0

.img-content-first
  position relative
  height 250px
  img
    position absolute
    left 0
    top 0
    width 100%
    height 100%
    -webkit-filter saturate(0.8)
  .title
    font-size 1.35em
    padding-right 80px
    position absolute
    color #fff
    -webkit-filter drop-shadow(5px 5px 5px #333)
    left 80px
    top 90px
    z-index 99

.img-content
  img
    -webkit-filter grayscale(0.8)
    height 140px
    width 100%
    padding-bottom 5px

.img-content, .topics-news
  display flex
  flex-direction column
  // align-items center
  // justify-content center
  span
    font-size 12px
    color rgba(0, 0, 0, 0.6)
    padding-top 5px
  .comp-time
    color rgba(0, 0, 0, 0.3)
  .title, .topics-news-title
    padding 8px 0
    font-size 14px
    color #284050

.topics-news-content
  padding 14px 8px
  .empty
    text-align center
    img
      height 120px
  .topics-news
    border-bottom 1px solid #D6DBE2
    padding-bottom 15px
    margin-bottom 8px
  .topics-news:last-child
    border 0

h2
  font-weight normal
  color #fff
  text-shadow 0 0 20px #7FA5A4

ul
  list-style-type none
  padding 0

li
  display inline-block
  margin 0 10px

a
  color #42b983

.desc
  width 100%
  overflow hidden
  white-space nowrap
  text-overflow ellipsis
</style>



// WEBPACK FOOTER //
// Competes.vue?3beedf76